// Fixed glassmorphism top navbar: page title and right-side controls.
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import NavbarLinks from "./NavbarLinks";

/**
 * Renders the admin top navbar with the active page title and the vertically
 * centered right-side controls (theme toggle, profile, mobile sidebar opener).
 * @param {Object} props - brandText (active page name), onOpenSidebar callback
 * @returns {React.ReactElement}
 */
export default function Navbar({ brandText, onOpenSidebar }) {
  const mainText = useColorModeValue("navy.700", "white");
  const navbarBg = useColorModeValue("rgba(244, 247, 254, 0.4)", "rgba(255, 255, 255, 0.06)");
  const borderColor = useColorModeValue("rgba(255, 255, 255, 0.5)", "rgba(255, 255, 255, 0.08)");
  return (
    <Box position="fixed" zIndex="10" bg={navbarBg} backdropFilter="blur(20px) saturate(140%)"
      WebkitBackdropFilter="blur(20px) saturate(140%)" border="1px solid" borderColor={borderColor}
      borderRadius="14px" boxShadow="0 8px 30px rgba(0, 0, 0, 0.20)"
      top="10px" right={{ base: "12px", md: "30px" }} left={{ base: "12px", xl: "330px" }}
      px={{ base: "14px", md: "20px" }} py="6px">
      <Flex align="center" justify="space-between" gap="12px">
        <Text color={mainText} fontSize={{ base: "15px", md: "18px" }} fontWeight="700"
          lineHeight="1.2" noOfLines={1} minW="0">
          {brandText}
        </Text>
        <NavbarLinks onOpenSidebar={onOpenSidebar} />
      </Flex>
    </Box>
  );
}
